import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';
const initialState = {
  entityList: [],
  entityListPaginated: [],
  parentEntityList: [],
  parentEntityListforFilter: [],
  loading: false,
  error: '',
};

export const GetEntityByParentId = createAsyncThunk(
  'entitity/GetEntityByParentId',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEntityByParentId(params.Id);
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const GetEntityByParentIdforFilter = createAsyncThunk(
  'entitity/GetEntityByParentIdforFilter',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEntityByParentId(params.Id);
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchEntityPaginatedEntity = createAsyncThunk(
  'entitity/fetchEntityPaginatedEntity',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEntityPaginated(params);
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchEntity = createAsyncThunk(
  'entitity/fetchEntity',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEntity();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          value: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          code: item.code,
          parentID: item?.parentID,
          parent: item?.parent?.nameEn,
          levelID: item?.level?.id,
          level: item?.level?.nameEn,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const entitySlice = createSlice({
  name: 'entity',
  initialState,
  reducers: {
    addNewEntity: (state, action) => {
      state.entityList = [
        {
          id: action.payload.id,
          value: action.payload.id,
          nameEn: action.payload.nameEn,
          nameAr: action.payload.nameAr,
          label: getLabel(action.payload.nameAr, action.payload.nameEn),
          code: action.payload.code,
          parentID: action.payload?.parentID,
          parent: action.payload?.parent,
          levelID: action.payload?.levelID,
          level: action.payload?.level,
        },
        ...state.entityList,
      ];
      state.loading = false;
      state.error = '';
    },
    updateEntity: (state, action) => {
      const updatedItem = {
        id: action.payload.id,
        value: action.payload.id,
        nameEn: action.payload.nameEn,
        nameAr: action.payload.nameAr,
        label: getLabel(action.payload.nameAr, action.payload.nameEn),
        code: action.payload.code,
        parentID: action.payload?.parentID,
        parent: action.payload?.parent,
        levelID: action.payload?.levelID,
        level: action.payload?.level,
      };
      const updatedList = state.entityList
        .filter((x) => x.id != '')
        .map((item) =>
          item.id === updatedItem.id ? { ...item, ...updatedItem } : item
        );
      state.entityList = [...updatedList, firstListItem];
      state.loading = false;
      state.error = '';
    },
    deleteEntity: (state, action) => {
      const filteredList = state.entityList.filter(
        (item) => item.id !== action.payload
      );
      state.entityList = filteredList;
      state.loading = false;
      state.error = '';
      console.log(state.entityList);
    },
    clearCurrentItem: (state) => {
      state.entityList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entityList = action.payload;
        state.error = '';
      })
      .addCase(fetchEntity.rejected, (state, action) => {
        state.loading = false;
        state.entityList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(GetEntityByParentId.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetEntityByParentId.fulfilled, (state, action) => {
        state.loading = false;
        const parentEntityList = action.payload;
        if (parentEntityList && parentEntityList?.length > 0) {
          state.parentEntityList = parentEntityList.map((item) => ({
            ...item,
            label: getLabel(item.nameAr, item.nameEn),
          }));
        } else {
          state.parentEntityList = parentEntityList;
        }
        state.error = '';
      })
      .addCase(GetEntityByParentId.rejected, (state, action) => {
        state.loading = false;
        state.parentEntityList = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(fetchEntityPaginatedEntity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEntityPaginatedEntity.fulfilled, (state, action) => {
        state.loading = false;
        state.entityListPaginated = action.payload;
        state.error = '';
      })
      .addCase(fetchEntityPaginatedEntity.rejected, (state, action) => {
        state.loading = false;
        state.entityListPaginated = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(GetEntityByParentIdforFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetEntityByParentIdforFilter.fulfilled, (state, action) => {
        state.loading = false;
        const parentEntityListforFilter = action.payload;
        if (
          parentEntityListforFilter &&
          parentEntityListforFilter?.length > 0
        ) {
          state.parentEntityListforFilter = parentEntityListforFilter.map(
            (item) => ({
              ...item,
              label: getLabel(item.nameAr, item.nameEn),
            })
          );
        } else {
          state.parentEntityListforFilter = parentEntityListforFilter;
        }
        state.error = '';
      })
      .addCase(GetEntityByParentIdforFilter.rejected, (state, action) => {
        state.loading = false;
        state.parentEntityListforFilter = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export const { addNewEntity, updateEntity, deleteEntity, clearCurrentItem } =
  entitySlice.actions;
export default entitySlice.reducer;
